/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

export default {
    /**
     * GET /carry-freight/api/journeyrequests/
     */
    getJourneyRequests: function (){
        return axios.get( FH_CONFIG.BASE_URL + '/carry-freight/api/journeyrequests')
    },

    /**
     * GET /carry-freight/api/journeyrequests/
     */
    getJourneyRequest: function ( id ){
        return axios.get( FH_CONFIG.BASE_URL + `/carry-freight/api/journeyrequests/${id}`)
    },

    /**
     * GET /carry-freight/api/journeyrequests/
     */
    postJourneyRequest: function ( { originPlaceId, destinationPlaceId, startTime, endTime } ){
        return axios.post( FH_CONFIG.BASE_URL + '/carry-freight/api/journeyrequests', {
            origin_place_id: originPlaceId,
            destination_place_id: destinationPlaceId,
            start_time: startTime,
            end_time: endTime,
        })
    },

    /**
     * DELETE /carry-freight/api/journeyrequests/{id}
     */
    deleteJourneyRequest: function( id ){
        return axios.delete( FH_CONFIG.BASE_URL + `/carry-freight/api/journeyrequests/${id}`);
    },
}